
export const selectFilteredData = (state: any) => {
  const { data, filters } = state.reportFilters

  return data.filter(item => item.campaignStatus === filters?.campaignStatus)
}